import { Fragment } from "react";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@volca/ui/components/ui/breadcrumb";
import { Stack } from "@volca/ui/components/ui/stack";
import { useCrumbsVisible, usePageCrumbs } from "./breadcrumbs-context";

export const AppBreadcrumbs = () => {
  const crumbs = usePageCrumbs();
  const visible = useCrumbsVisible();
  if (!visible || !crumbs || crumbs.length === 0) return null;

  return (
    <Stack
      direction="row"
      align="center"
      className="h-10 shrink-0 border-b border-line"
    >
      <Breadcrumb className="mx-auto flex h-full w-full max-w-[1680px] items-center px-4 md:px-8">
        <BreadcrumbList className="min-w-0 flex-nowrap">
          {crumbs.map((crumb, index) => {
            const isLast = index === crumbs.length - 1;
            return (
              <Fragment key={`${index}-${crumb.label}`}>
                <BreadcrumbItem className="min-w-0">
                  {isLast ? (
                    <BreadcrumbPage className="truncate" title={crumb.label}>
                      {crumb.label}
                    </BreadcrumbPage>
                  ) : crumb.href ? (
                    <BreadcrumbLink
                      className="truncate"
                      title={crumb.label}
                      render={<Link to={crumb.href} state={crumb.state} />}
                    >
                      {crumb.label}
                    </BreadcrumbLink>
                  ) : (
                    <span className="truncate" title={crumb.label}>
                      {crumb.label}
                    </span>
                  )}
                </BreadcrumbItem>
                {!isLast && <BreadcrumbSeparator />}
              </Fragment>
            );
          })}
        </BreadcrumbList>
      </Breadcrumb>
    </Stack>
  );
};
